import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { TbEye } from "react-icons/tb";
import ViewUser from "../../Package/Assets/ViewModel";

const ApproveModal = ({ itemName, onClose, onApprove }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [packageData, setPackageData] = useState([]);
  const [viewUserModel, setViewUserModel] = useState(false);
  const [itemToView, setItemToView] = useState(null);

  const [formData, setFormData] = useState({
    packageId: "",
  });

  const Auth = localStorage.getItem("authToken");

  useEffect(() => {
    fetchPackageData();
  }, []);

  const fetchPackageData = async () => {
    try {
      const response = await fetch(
        "https://support.ace-school-backend.serverscripts.in/api/v1/admin/package/view",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Auth}`,
          },
        }
      );

      const result = await response.json();

      if (!result.success) {
        throw new Error("Failed to fetch package data");
      }

      setPackageData(result.data || []);
    } catch (err) {
      console.error("Package data fetch error:", err);
    }
  };

  const handleApprove = async () => {
    if (!formData.packageId) {
      alert("Please select a package");
      return;
    }

    setLoading(true);

    try {
      console.log("Approving with data:", formData);
      await onApprove(formData);
    } catch (error) {
      console.error(error);
    }

    setLoading(false);
  };

  const handleViewClick = (item) => {
    setItemToView(item);
    setViewUserModel(true);
  };

  const cancelView = () => {
    setViewUserModel(false);
    setItemToView(null);
  };

  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl w-full max-w-md p-6 shadow-lg">
        <div className="text-center">
          <svg
            className="mx-auto h-12 w-12 text-green-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M5 13l4 4L19 7"
            />
          </svg>

          <h3 className="mt-3 text-lg font-semibold text-gray-900">
            Approve {itemName}
          </h3>

          <p className="mt-2 text-sm text-gray-500">
            Are you sure you want to approve this {itemName}?
          </p>

          <div className="mt-5">
            <label className="labelStyle font-semibold block mb-2">
              Choose Package
            </label>

            <div className="space-y-2 border rounded-md p-2 max-h-60 overflow-y-auto">
              {packageData.length > 0 ? (
                <>
                  {packageData.map((pkg, index) => (
                    <div
                      key={index}
                      className={`flex items-center justify-between border rounded-md px-3 py-2 cursor-pointer transition ${
                        formData.packageId === pkg.id
                          ? "border-blue-500 bg-blue-50"
                          : "hover:bg-gray-50"
                      }`}
                    >
                      <div
                        onClick={() =>
                          setFormData((prev) => ({
                            ...prev,
                            packageId: pkg.id,
                          }))
                        }
                        className={`flex-1 ${
                          formData.packageId === pkg.id
                            ? "text-blue-600 font-semibold"
                            : "text-gray-700"
                        }`}
                      >
                        {pkg.packageName}
                      </div>

                      <button
                        type="button"
                        onClick={() => handleViewClick(pkg)}
                        className="text-blue-500 hover:text-blue-700"
                      >
                        <TbEye size={20} />
                      </button>
                    </div>
                  ))}

                  <div
                    onClick={() => navigate("/view-package")}
                    className="border border-dashed rounded-md px-3 py-2 text-center text-green-600 font-medium cursor-pointer hover:bg-green-50"
                  >
                    + Add Package
                  </div>
                </>
              ) : (
                <div className="text-gray-500 text-sm text-center py-3">
                  No packages available
                </div>
              )}
            </div>
          </div>

          <div className="mt-5 flex justify-center gap-3">
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200"
            >
              Cancel
            </button>

            <button
              type="button"
              onClick={handleApprove}
              disabled={loading}
              className="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-md hover:bg-green-700"
            >
              {loading ? "Approving..." : "Approve"}
            </button>
          </div>
        </div>
      </div>

      {viewUserModel && (
        <ViewUser
          user={itemToView}
          onClose={cancelView}
        />
      )}
    </div>
  );
};

export default ApproveModal;